// SSO orense : login/logout centralisés sur le service d'identité compte.orense.ch.
// PL n'a plus de formulaire de login local — on redirige le navigateur vers l'IdP,
// qui pose le cookie partagé `.orense.ch` puis ramène ici via `next`.
const COMPTE = "https://compte.orense.ch";
const PORTAL = "https://orense.ch";

export function goToLogin(): void {
  window.location.href = `${COMPTE}/login?next=${encodeURIComponent(window.location.href)}`;
}

export function goToLogout(): void {
  window.location.href = `${COMPTE}/logout?next=${encodeURIComponent(PORTAL)}`;
}
